var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShotAutoplayAuto = function SvgShotAutoplayAuto(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17855 9.61358L7.42918 11.8334H5.03444L9.12342 0.166748H11.7788L15.8678 11.8334H13.4568L12.7074 9.61358H8.17855ZM12.0883 7.74424L10.443 2.87061L8.7976 7.74424H12.0883Z",
    fill: "#E5E4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 10.1667H3.92176L3.33936 11.8334H0.132812V10.1667Z",
    fill: "#E5E4EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23295 0.166748H0.132812V1.83341H6.66474L7.23295 0.166748Z",
    fill: "#E5E4EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 3.56885H6.10421L5.52449 5.23551H0.132812V3.56885Z",
    fill: "#E5E4EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03444 6.8678H0.132812V8.53446H4.45334L5.03444 6.8678Z",
    fill: "#E5E4EC"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShotAutoplayAuto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shot-autoplay-auto.9563b7b084edf7379b20fe58459e77f4.svg";